import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Footer from './components/sitePages/Footer';
import SiteProvider from './context/SiteProvider';
import Layout from './components/sitePages/Layout';
import './styles/site.scss';
import CircularProgress from '@mui/material/CircularProgress';

const App = (): JSX.Element => {
  return (
    <div className='site-wrapper'>
      <SiteProvider>
        <BrowserRouter>
          <main className='flex-row'>
            <Suspense
              fallback={
                <div className='loading-container'>
                  <CircularProgress />
                </div>
              }>
              <Layout />
            </Suspense>
          </main>
          <Footer />
        </BrowserRouter>
      </SiteProvider>
    </div>
  );
};

export default App;
